import { Check, X } from 'lucide-react';
import clsx from 'clsx';

type Rule = {
  col: number;
  value: any;
  func: string;
};

type ListTableProps = {
  data: any[];
  columns: any[];
  rule?: Rule | Rule[];
};

export const ListTable = ({ data, columns, rule }: ListTableProps) => {
  // Função que avalia se uma linha satisfaz todas as regras
  const evaluateRules = (row: any[]): boolean => {
    if (!rule) return false;
    // Se rule não for um array, encapsula-o em um array
    const rulesArray: Rule[] = Array.isArray(rule) ? rule : [rule];

    return rulesArray.every((r) => {
      const cell = row[r.col];
      switch (r.func) {
        case '=':
        case '==':
        case '===':
          return cell === r.value;
        case '!=':
        case '!==':
          return cell !== r.value;
        case '>':
          return cell > r.value;
        case '>=':
          return cell >= r.value;
        case '<':
          return cell < r.value;
        case '<=':
          return cell <= r.value;
        case 'contains':
          return typeof cell === 'string' && cell.includes(r.value);
        default:
          console.warn(`Operador ${r.func} não implementado.`);
          return false;
      }
    });
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((col) => (
              <th
                key={col} // É uma boa prática adicionar uma chave única para cada elemento iterado
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row: any, rowIndex: number) => (
            <tr
              key={rowIndex} // Usando índices como chaves pode ser uma escolha, mas só se os dados não mudarem em tamanho/ordem
              className={clsx(
                'hover:bg-gray-50 transition-colors',
                rule && evaluateRules(row) && 'bg-red-50'
              )}
            >
              {row.map((col: any, colIndex: number) => (
                <td key={colIndex} className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm font-medium text-gray-900">{col}</span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
